import { render, staticRenderFns } from "./AcceptanceTypeToggle.vue?vue&type=template&id=7485e51c&scoped=true"
import script from "./AcceptanceTypeToggle.vue?vue&type=script&lang=ts"
export * from "./AcceptanceTypeToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485e51c",
  null
  
)

export default component.exports